import React, { Component } from 'react';
import { connect } from 'react-redux';
import { activeStepCheckout, activeStepCreate } from '../modules/active_enroll_step';
import { unSoftUpgradePositiveMember } from '../modules/membership_actions';
import { closeModal } from '../modules/active_modal';
import UpgradeAcceptTerms   from './UpgradeAcceptTerms.jsx';
import EnrollCheckout       from './EnrollCheckout.jsx';
import EnrollPaymentInfo    from './EnrollPaymentInfo.jsx'; //obsolete
import EnrollCustomerInfo from './EnrollCustomerInfo.jsx';//obsolete
import EnrollUpdateCustomerInfo from './EnrollUpdateCustomerInfo.jsx';
import { removeEnrollItem } from '../modules/cart_actions';

class ModalUpgradeFlow extends Component {

  constructor(props){
    super(props);
  }

  cancelUpgrade(){
    if(this.props.customer.fulfillment_type === "Positive" && this.props.activeUpgradeStep === "upgradeTerms")
      this.props.dispatch( unSoftUpgradePositiveMember() );
    else this.props.dispatch( closeModal());
  }

  render() {
    let {dispatch}           = this.props;
    let oCartErrorMessaging  = '';
    let oEnrollErrorMessaging  = '';
    let oFeaturedItem        = this.props.computedCart.items[0];
    let oCatalogItem         = this.props.computedCart.items[1];
    let sFeaturedRow         = '';
    let sCatagoryRow         = '';
    let oCart                = '';
    let sActiveEnrollStep    = '';
    let activeUpgradeStep    = this.props.activeUpgradeStep;
    let prettySubtotal       = parseFloat(this.props.computedCart.subtotal).toFixed(2);

    if (!oFeaturedItem) {
      sFeaturedRow = (
        <tr className="cart-item">
          <td colSpan="3">
            <h5 className="highlight-color">Add a Featured Selection for $11.99!</h5>
          </td>
        </tr>
      )
    } else {
      sFeaturedRow =(
        <tr className="nm-cart-item">
          <td className="col-1">
              <div className="nm-cart-item-wrapper">
                <div className={"remove inline hidden"} onClick={() => this.props.dispatch(removeEnrollItem(0))}>
                  <svg version="1.1"x="0px" y="0px"
                     width="22.666px" height="22.667px" viewBox="0 0 22.666 22.667" enable-background="new 0 0 22.666 22.667" >
                    <circle id="bgFill" fill="#FFFFFF" cx="11.436" cy="11.108" r="9.522"/>
                    <path fill="#231F20" d="M11.379,22.325c-6.108,0-11.078-4.969-11.078-11.077S5.271,0.169,11.379,0.169s11.077,4.97,11.077,11.078
                    S17.487,22.325,11.379,22.325z M11.379,2.669c-4.73,0-8.578,3.848-8.578,8.578c0,4.729,3.848,8.577,8.578,8.577
                    c4.729,0,8.577-3.848,8.577-8.577C19.956,6.518,16.108,2.669,11.379,2.669z"/>
                    <polygon fill="#231F20" points="17.634,6.758 15.866,4.991 11.462,9.396 7.057,4.991 5.29,6.758 9.694,11.164 5.29,15.57
                    7.057,17.337 11.462,12.932 15.866,17.337 17.634,15.57 13.229,11.164 "/>
                  </svg>
                </div>
                <img src={"//s3.amazonaws.com/bookspan-media/covers/thumb/" + oFeaturedItem.mmid + ".jpg"} />
             </div>
           </td>
           <td className="col-2">
             <span className="title">{oFeaturedItem.title}</span>
             <br />
             {oFeaturedItem.author}
           </td>
          <td className="col-3">${oFeaturedItem.computed_price.toFixed(2)}</td>
        </tr>
      )
    }

    if (!oCatalogItem) {
      sCatagoryRow = (
        <tr className="cart-item">
          <td colSpan="3">
            <h5 className="highlight-color">Add any book from the Catalog for only ${this.props.second_book}!</h5>
          </td>
        </tr>
      )
    } else {
      sCatagoryRow =(
        <tr className="nm-cart-item">
          <td className="col-1">
              <div className="nm-cart-item-wrapper">
                <div className={"remove inline hidden"} onClick={() => this.props.dispatch(removeEnrollItem(1))}>
                  <svg version="1.1"x="0px" y="0px"
                     width="22.666px" height="22.667px" viewBox="0 0 22.666 22.667" enable-background="new 0 0 22.666 22.667" >
                    <circle id="bgFill" fill="#FFFFFF" cx="11.436" cy="11.108" r="9.522"/>
                    <path fill="#231F20" d="M11.379,22.325c-6.108,0-11.078-4.969-11.078-11.077S5.271,0.169,11.379,0.169s11.077,4.97,11.077,11.078
                    S17.487,22.325,11.379,22.325z M11.379,2.669c-4.73,0-8.578,3.848-8.578,8.578c0,4.729,3.848,8.577,8.578,8.577
                    c4.729,0,8.577-3.848,8.577-8.577C19.956,6.518,16.108,2.669,11.379,2.669z"/>
                    <polygon fill="#231F20" points="17.634,6.758 15.866,4.991 11.462,9.396 7.057,4.991 5.29,6.758 9.694,11.164 5.29,15.57
                    7.057,17.337 11.462,12.932 15.866,17.337 17.634,15.57 13.229,11.164 "/>
                  </svg>
                </div>
                <img src={"//s3.amazonaws.com/bookspan-media/covers/thumb/" + oCatalogItem.mmid + ".jpg"} />
             </div>
           </td>
           <td className="col-2">
             <span className="title">{oCatalogItem.title}</span>
             <br />
             {oCatalogItem.author}
           </td>
          <td className="col-3">${oCatalogItem.price}</td>
        </tr>
      )
    }

    switch(this.props.activeUpgradeStep){
      case 'upgradeTerms':
        sActiveEnrollStep = ( <UpgradeAcceptTerms /> );
        oEnrollErrorMessaging = (
          <div className={"errorMessage hidden " + (this.props.accountCreationError ? 'showing' : '')}>
            <p>{this.props.accountCreationError}</p>
          </div>
        );
      break;

      case 'upgradeCheckout':
        sActiveEnrollStep = (<EnrollCheckout upgradeFlow={true} /> );
        oCartErrorMessaging         = this.props.cartError ? (
          <div className='errorMessage showing'>
            <p>{this.props.cartError}</p>
          </div>
          ) : '';
      break;

      default:
        sActiveEnrollStep = 'An error has occured';
    }

    oCart = (
    <div className="content-max-width">
      <div className="modal-body">
          {oEnrollErrorMessaging}
          {oCartErrorMessaging}
          {sActiveEnrollStep}
      </div>
    </div>
    );

    let oCartHeader = (

      <div className="enroll-cart-header center">
        <div className="centerLine"><hr/></div>
        <ul>
          <li id="enrollCreateAccount" className={(activeUpgradeStep === 'upgradeTerms' ? 'active' : '')} >
            <div className="number-steps"><span>1</span></div>
            <h4>Upgrade</h4>
          </li>
          <li id="enrollCheckout" className={(activeUpgradeStep === 'upgradeCheckout' ? 'active' : '')} >
            <div className="number-steps"><span>2</span></div>
            <h4>Checkout</h4>
          </li>
          <li>
            <div className="number-steps"><span>3</span></div>
            <h4>Enjoy!</h4>
          </li>
        </ul>
      </div>
    )

    return (
      <div className="enroll-cart">
        <div className="modal-header content-max-width enroll-steps">
          <div className="button-wrapper">
            <button className="modal-closer btn-secondary" onClick={this.cancelUpgrade.bind(this)}>&times;</button>
          </div>
          {oCartHeader}
        </div>
        {oCart}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'second_book': state.store.second_book,
      'customer': state.customer,
      'cartError': state.cartError,
      'computedCart': state.computedCart,
      'activeUpgradeStep': state.activeUpgradeStep,
      'accountCreationError': state.accountCreationError
    };
}

export default connect(mapStateToProps)(ModalUpgradeFlow);



// WEBPACK FOOTER //
// ./src/components/ModalUpgradeFlow.jsx